import * as Yup from 'yup';

export const configurationSchema = Yup.object({
  configName: Yup.string()
    .required('Configuration Name is required'),
  configValue: Yup.string()
    .required('Configuration Value is required')
});